/**
 * @fileoverview Agent definition for world-place-snapshotter-v3.
 *
 * This agent analyzes a chapter and updates a world place's state,
 * creating a snapshot that reflects any changes from the chapter events.
 *
 * @category world-building.places.snapshots
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'world-place-snapshotter-v3',
  kind: 'primitive',
  name: 'World Place Snapshotter',
  description: 'Updates a world place state after a chapter, creating a point-in-time snapshot.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    taxonomyPath: 'world-building.places.snapshots',
    usedBy: [
      'use-world-place-snapshotter-v3.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'world-place-details-generator-v3',
    ],
  },
};
